export default __webpack_public_path__ + "static/media/beauty_2020_OV_seemore_EH-HS99_8_201029.b3c3b903.jpg";